import http from "infra/http";
import { useMutation } from "react-query";
import PerfilEvents from "../events";

export default function usePostPerfil(tenantId?: string) {
  return useMutation(async (body: any) => {
    const headers = { tenant: tenantId ?? null };
    if (body.id) {
      PerfilEvents.atualizar(body.id);

      const { data } = await http.put(`/v1/perfil/${body.id}`, body, {
        headers,
      });

      return data;
    }

    PerfilEvents.criar();

    const { data } = await http.post("/v1/perfil", body, { headers });

    return data;
  });
}
